import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import { dataHooks } from './constants';
var Tab = function Tab(_ref) {
  var getClassName = _ref.getClassName,
    label = _ref.label,
    shouldTranslate = _ref.shouldTranslate,
    showDotIndicator = _ref.showDotIndicator;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-tab'),
    "data-hook": dataHooks.tab
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: label,
    shouldTranslate: shouldTranslate
  }), showDotIndicator ? /*#__PURE__*/React.createElement("span", {
    key: "showDotIndicator",
    className: "dot-indicator"
  }) : null);
};
Tab.displayName = displayNames.TAB;
Tab.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** @deprecated */
  value: PropTypes.string.isRequired,
  /** Text content to show in tab header */
  label: PropTypes.string.isRequired,
  /** Set to `true` to show a dot (pimple) in the tab header */
  showDotIndicator: PropTypes.bool
};
export default compose(Tab);